/**
 * @flow
 */

import React, { Component } from 'react'
import Helmet from 'react-helmet'
import 'lazysizes'

import franchiseTheme from '../../constants/themeConstants/franchiseTheme'

import Header from '../../components/Header'
import LandingSection from '../../components/ExperimentalMarketing/LandingSection'
import IbCricketAtIpl2019 from '../../components/ExperimentalMarketing/IbCricketAtIpl2019'
import ExperimentalMarketingSection from '../../components/ExperimentalMarketing/ExperimentalMarketingSection'
import PlacesToPlayIbcricket from '../../components/ExperimentalMarketing/PlacesToPlayIbcricket'
import PortfolioSection from '../../components/ExperimentalMarketing/PortfolioSection'
import FooterMessageSection from '../../components/ExperimentalMarketing/FooterMessageSection'
import Footer from '../../components/core/Footer'
import bookNowConstants from '../../constants/bookNowFormConstants'

class ExperimentalMarketing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      glsLoaded: false
    }
  }

  initMap = () => {
    this.setState({
      glsLoaded: true
    })
  }

  loadGooglePlacesScript() {
    try {
      window.initMap = this.initMap
      const gmapScriptEl = document.createElement(`script`)
      gmapScriptEl.src = bookNowConstants.GOOGLE_SCRIPT_URL
      document
        .querySelector(`body`)
        .insertAdjacentElement(`beforeend`, gmapScriptEl)
    } catch (error) {
      console.log(error)
    }
  }

  componentDidMount() {
    if (!window.google) {
      this.loadGooglePlacesScript()
    }
    if (window.google) {
      this.initMap()
    }
  }
  render() {
    const { glsLoaded } = this.state
    const { footerProps, data } = this.props
    const {
      experimentalMarketingPageData: { edges: experimentalMarketingPageData },
      applyForFranchiseData: { edges: formData }
    } = data
    const {
      iBCricketAtIplSectionData,
      experientialMarketingWithibcData,
      portfolioSectionData,
      footerMessageSection,
      seoData,
      PlacesToPlayIbcricketData,
      landingSectionData
    } = experimentalMarketingPageData[0].node.frontmatter

    const {
      title,
      metaDescription,
      ogTitle,
      ogWebsiteUrl,
      ogDescription,
      ogType,
      ogSiteName,
      twitterUrl,
      twitterSite,
      twitterCard,
      twitterTitle,
      twitterdescription,
      canonicalurl
    } = seoData
    return (
      <div>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={metaDescription} />
          <meta property="og:title" content={ogTitle} />
          <meta property="og:url" content={ogWebsiteUrl} />
          {/* <meta property="og:image" content={ogImageUrl} /> */}
          <meta property="og:description" content={ogDescription} />
          <meta property="og:type" content={ogType} />
          <meta property="og:site_name" content={ogSiteName} />
          <meta property="twitter:title" content={twitterTitle} />
          <meta name="twitter:url" content={twitterUrl} />
          <meta name="twitter:site" content={twitterSite} />
          <meta name="twitter:card" content={twitterCard} />
          <meta property="twitter:description" content={twitterdescription} />
          {/* <meta name="twitter:image" content={twitterImage} /> */}
          <link rel="canonical" href={canonicalurl} />
        </Helmet>
        <Header formData={formData} />
        <LandingSection
          formData={formData}
          glsLoaded={glsLoaded}
          landingSectionData={landingSectionData}
        />
        <IbCricketAtIpl2019
          id="ibCricket-at-ipl-section"
          iBCricketAtIplSectionData={iBCricketAtIplSectionData}
        />
        <ExperimentalMarketingSection
          sectionId="experiential-marketing-services"
          experientialMarketingWithibcData={experientialMarketingWithibcData}
          formData={formData}
          glsLoaded={glsLoaded}
        />
        <PlacesToPlayIbcricket
          PlacesToPlayIbcricketData={PlacesToPlayIbcricketData}
          formData={formData}
          glsLoaded={glsLoaded}
        />
        <PortfolioSection
          portfolioSectionData={portfolioSectionData}
          id="port-folio-section"
          formData={formData}
          glsLoaded={glsLoaded}
        />
        <FooterMessageSection
          footerMessageSection={footerMessageSection}
          id="footer-message-section"
        />
        <Footer {...footerProps} theme={franchiseTheme.footerSection} />
      </div>
    )
  }
}

export default ExperimentalMarketing

// eslint-disable-next-line
export const graphqlQuery = graphql`
  query ExperimentalMarketingPageQuery {
    experimentalMarketingPageData: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/content/experimental-marketing-page/" }
      }
      sort: { fields: [frontmatter___order], order: ASC }
    ) {
      edges {
        node {
          frontmatter {
            landingSectionData {
              heading
              mobileHeading
              description
            }

            worldCupSectionData {
              title
              description
              buttonText
            }
            iBCricketAtIplSectionData {
              title
              statsList {
                statsImage
                statsDescription
                statsDescriptionHeading
                statsNumber
                statsVideo
                statsVideoM2V
                statsVideoMp4
              }
              partnersList {
                logoUrl
              }
              testimonialsList {
                testimonialDescription
                testimonialName
                country
              }
            }
            experientialMarketingWithibcData {
              title
              description
              sectionsData {
                sectionid
                title
                description
                mainImage
                mobileImage
                videoId
                buttonText
              }
            }

            PlacesToPlayIbcricketData {
              heading
              eligibilityImage
              eligibilityImagealt
              placesList {
                image
                alt
                text
              }
            }

            brandActivationSectionData {
              title
              contentHeading
              description
              videoId
              videoThumbnailUrl
              videoAltText
              buttonText
              iconsList {
                iconTitle
                iconName
                iconDescription
                imageUrl
                iconWidth
                iconHeight
              }
            }

            portfolioSectionData {
              id
              cardImgUrl
              cardImgalt
              isVideo
              videoThumbnailUrl
              videoAltText
              videoId
              heading
              description
              ReadmoreCta
              ReadMoreURL
            }
            footerMessageSection {
              desktopContent
              mobileContent
            }
            seoData {
              title
              metaDescription
              ogTitle
              ogWebsiteUrl
              ogDescription
              ogType
              ogSiteName
              twitterUrl
              twitterSite
              twitterTitle
              twitterdescription
              canonicalurl
            }
          }
        }
      }
    }

    applyForFranchiseData: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/content/viu/ibc-apply-franchise-data/" }
      }
    ) {
      edges {
        node {
          frontmatter {
            title
            pageHeading
            pageSubHeading
            formHeading
            nameFieldPlaceholder
            emailFieldPlaceholder
            phoneNumberFieldPlaceholder
            occupationFieldPlaceholder
            locationFieldPlaceHolder
            ctaButtonText
            thankYouTextOne
            thankYouTextTwo
            backgroundImage
            mobilBackgroundImage
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/vr-experiential-marketing/index.js